<template>
  <main>
    <button @click="showPopup = true" class="absolute deposit-fund-button">
      Fund Deposit
    </button>
    <vs-popup
      ref="transactionDetailsRef"
      title="Deposit Funds"
      :active.sync="showPopup"
    >
      <p class="text-grey mb-3">Redeem Coupon Code</p>
      <div class="w-full">
        <vs-input
          v-model="couponCode"
          class="w-full coupon-code"
          @input="verifyCouponCode"
          @keyup.enter="verifyCouponCode"
        />
        <span v-if="couponCode && !validCouponCode" class="text-danger mt-5"
          >Invalid Coupon Code</span
        >
      </div>

      <vs-divider class="mb-base" />

      <p class="text-grey mb-3">Enter Amount</p>
      <div class="w-full mb-3">
        <vs-input
          v-model="amount"
          class="w-full"
          type="Number"
          :disabled="validCouponCode"
        />
        <span v-if="amount < 0" class="text-danger mt-5">Invalid Amount</span>
      </div>

      <div class="flex justify-content-end mb-base">
        <div
          class="mr-3 cursor-pointer x-plus-amount"
          color="primary"
          @click="xPlusAmount(1000)"
        >
          + €1000
        </div>
        <div
          class="mr-3 cursor-pointer x-plus-amount"
          color="primary"
          @click="xPlusAmount(2000)"
        >
          + €2000
        </div>
        <div
          class="mr-3 cursor-pointer x-plus-amount"
          color="primary"
          @click="xPlusAmount(5000)"
        >
          + €5000
        </div>
      </div>
      <vs-button
        v-if="!validCouponCode"
        class="w-full mb-4"
        @click.prevent="addFunds('stripe')"
        :disabled="!validAmount"
        >Add Funds</vs-button
      >
      <vs-button
        v-else
        class="w-full mb-4"
        @click.prevent="addFunds('coupon_code')"
        >Add Funds</vs-button
      >
    </vs-popup>
  </main>
</template>

<script>
import constants from "@/constants";
export default {
  components: {},
  props: {},
  computed: {
    validAmount() {
      return this.amount && this.amount > 0;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    couponAmount() {
      return Number(this.couponCode.toUpperCase().split("GTBRDD")[1]);
    },
  },
  data() {
    return {
      constants,
      showPopup: false,
      couponCode: null,
      validCouponCode: false,
      validCouponCodes: ["GTBRDD2000", "GTBRDD5000", "GTBRDD10000"],
      transactions: [],
      amount: 0,
      currency: "eur",
    };
  },
  watch: {
    showPopup(val) {
      this.couponCode = "";
      this.amount = 0;
      this.validCouponCode = false;
      this.verifyCouponCode();
    },
  },
  methods: {
    xPlusAmount(x) {
      if (!this.validCouponCode) this.amount = Number(this.amount) + x;
    },
    verifyCouponCode() {
      this.validCouponCode = false;
      if (
        this.couponCode &&
        this.validCouponCodes.includes(this.couponCode.toUpperCase())
      ) {
        this.validCouponCode = true;
        this.amount = this.couponAmount;
      }
    },
    addFunds(source) {
      if (!this.orgData || !this.userData) return;

      this.$vs.loading();

      let amount = 0;
      if (source === "coupon_code") {
        amount = this.couponAmount;
      } else {
        amount = this.amount;
      }

      if (amount === 0) {
        this.$vs.notify({
          title: "Invalid Amount Value",
          color: "danger",
        });
        return;
      }

      const payload = {
        organizationId: this.orgData._id,
        userId: this.userData._id,
        amount,
        currency: this.currency,
        source: source,
        couponCode: this.couponCode,
        stripeProductName: "Organization Funds",
      };

      this.$store
        .dispatch("payments/addFunds", payload)
        .then((res) => {
          if (source === "stripe") {
            window.location.href = res.data.data.stripeRedirectURL;
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: `Successfully added €${amount} to Organization Funds`,
              color: "primary",
            });

            this.$emit("addFundsSuccess");
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Failed to add Organization Funds",
            color: "danger",
          });

          this.$emit("addFundsFailed");

          throw err;
        });

      this.couponCode = "";
      this.amount = 0;
      this.showPopup = false;
    },
  },
};
</script>

<style scoped>
.deposit-fund-button {
  top: 5px;
  right: 9px;
  border: 2px solid black;
  border-radius: 20px !important;
  background: inherit;
  padding: 7px 14px;
  font-weight: bolder;
}
.justify-content-end {
  justify-content: end;
}
.x-plus-amount {
  color: #ffffff;
  background-color: rgba(var(--vs-primary));
  border-radius: 15px;
  padding: 2px 5px;
  font-size: 12px;
}
.table-container {
  box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  background: #fff;
  border-radius: 0.5rem;
}
.btn-bottom {
  background: #f2c046;
  border-radius: 1.7rem !important;
  padding: 1rem 2rem;
}
.link {
  color: #3b72ed;
}
.total {
  color: #12b76a;
}
.divider {
  margin: 0 -20px;
}
.con-vs-popup >>> .vs-popup--content {
  padding-bottom: 0 !important;
}
</style>
